import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';

export default function SuccessPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="success-page">
      <div className="success-page-icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <h2>{t('onboarding.success.title')}</h2>
      <p>{t('onboarding.success.message')}</p>
      <div className="success-page-actions">
        <button className="wizard-btn wizard-btn-primary" onClick={() => navigate('/dashboard', { replace: true })}>
          {t('onboarding.success.dashboard')}
        </button>
      </div>
    </div>
  );
}
